import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`

.sub-menu {
  padding: 16px;
}

:global(.ot-floating-button) {
  display: none !important;
}
ul {
  margin: 0;
  padding: 0px 0px 0px 0px;
  list-style: none;
}
.featureTab-Wrapper{
  position: unset;
  width: 100%;
  z-index: 9;
  padding-top: 16px;
}

p {
  color: ${colors.primaryText};
  font-display:optional;
}
.featured {
  margin-top: 24px;
}

.featured-tab-item {
  display: block;
}
.recommended {
  margin-left: 0px;
  margin-right: 0px;
  margin-top: 0px;
}


@media (min-width: 768px) {
  .sub-menu {
    padding: 8px 0 0;
  }
  .featured {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 16px;
    margin-right: 16px;
  }
  .mpu-container {
    margin-left: 24px;
  }
  .featureTab-Wrapper{
    position: relative;
    top: unset;
    margin-top : 0px;
  }
  .featured-videos {
    width: ${(7 / 12) * 100}%;
    padding-right: 16px;
  }
  .featured-sidebar {
    width: ${(5 / 12) * 100}%;
    align-items: flex-end;
    max-width: 340px;
  }
  .featured-tabs-content {
    display: flex;
    flex-grow: 1;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .tab-loader {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  .recommended h2 {
    margin-bottom: 0.5em;
  }
}

`
